import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import CommonClaims from 'templates/CommonClaims';
import { GlobalContext } from 'context';

function PayYourSentaraBill() {
  //  Initialize useTranslation hook
  const { t } = useTranslation();
  const { ssoEndPoints } = useContext(GlobalContext);
  return (
    <CommonClaims
      staticUrlLink={ssoEndPoints?.paySentaraBillSignInURL ?? ''}
      claimTitle={t('common.payYourSentaraBill')}
      claimMsg={t('payYourSentaraBill.billPaymentMsg')}
      analyticsFeatureName="Pay_your_bill"
    />
    
      
  );
}

export default PayYourSentaraBill;
